import React, { useState } from 'react';
import styles from './style';

const ButtonBorder = (props) => {
  const { children, color, textColor, onClick, hoverColor, border, padding, width, size, hoverBgColor } = props;

  const [hover, setHover] = useState(false);

  const buttonStyles = { ...styles.buttonBorder };
  if (color) {
    buttonStyles.backgroundColor = color;
  }
  if (textColor) {
    buttonStyles.color = textColor;
  }
  if (border) {
    buttonStyles.borderColor = border;
  }
  if (padding) {
    buttonStyles.padding = padding;
  }
  if (width) {
    buttonStyles.width = width;
  }
  if (size) {
    buttonStyles.fontSize = size;
  }

  return (
    <button
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      type="button"
      style={
        hover
          ? {
              ...buttonStyles,
              borderColor: hoverColor || 'none',
              backgroundColor: hoverBgColor || 'none'
            }
          : { ...buttonStyles }
      }
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default ButtonBorder;
